import { defineComponent as _defineComponent } from 'vue'
import { useBilling } from '@/components/Billing/Billing.composables';
import { LEARN_MORE_OVERAGES_LINK } from '@/components/Billing/billing-service.const';


export default /*#__PURE__*/_defineComponent({
  __name: 'BillingOveragesTooltip',
  setup(__props) {

const { setDocsOpen } = useBilling();

const openLearnMoreLink = () => setDocsOpen(LEARN_MORE_OVERAGES_LINK);

return { __sfc: true,setDocsOpen, openLearnMoreLink }
}

})